/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface WaypointExecutionMode {
}

export enum WaypointExecutionMode_Enum {
  CAPTURE = 0,
  PAUSE = 1,
  SKIP = 2,
  UNRECOGNIZED = -1,
}

export function waypointExecutionMode_EnumFromJSON(object: any): WaypointExecutionMode_Enum {
  switch (object) {
    case 0:
    case "CAPTURE":
      return WaypointExecutionMode_Enum.CAPTURE;
    case 1:
    case "PAUSE":
      return WaypointExecutionMode_Enum.PAUSE;
    case 2:
    case "SKIP":
      return WaypointExecutionMode_Enum.SKIP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WaypointExecutionMode_Enum.UNRECOGNIZED;
  }
}

export function waypointExecutionMode_EnumToJSON(object: WaypointExecutionMode_Enum): string {
  switch (object) {
    case WaypointExecutionMode_Enum.CAPTURE:
      return "CAPTURE";
    case WaypointExecutionMode_Enum.PAUSE:
      return "PAUSE";
    case WaypointExecutionMode_Enum.SKIP:
      return "SKIP";
    case WaypointExecutionMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseWaypointExecutionMode(): WaypointExecutionMode {
  return {};
}

export const WaypointExecutionMode = {
  encode(_: WaypointExecutionMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaypointExecutionMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypointExecutionMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaypointExecutionMode {
    return {};
  },

  toJSON(_: WaypointExecutionMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaypointExecutionMode>, I>>(base?: I): WaypointExecutionMode {
    return WaypointExecutionMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaypointExecutionMode>, I>>(_: I): WaypointExecutionMode {
    const message = createBaseWaypointExecutionMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
